// extracted by mini-css-extract-plugin
export var button = "_s-0";
export var buttonContent = "_s-e";
export var buttonGroup = "_s-c";
export var dontRestrainIconWidth = "_s-a";
export var dropdownButton = "_s-b";
export var iconContainer = "_s-9";
export var lg = "_s-4";
export var md = "_s-3";
export var pending = "_s-f";
export var sm = "_s-2";
export var spinner = "_s-d";
export var squared = "_s-8";
export var wrapText = "_s-g";
export var xl = "_s-5";
export var xs = "_s-1";
export var xxl = "_s-6";
export var xxxl = "_s-7";